export const roundDecimalValueUptoTwo = (number) => {
	// for two digit
	// return Math.round((number + Number.EPSILON) * 100) / 100;
	// for one digit
	return Math.round((number + Number.EPSILON) * 10) / 10;
};
export const roundDecimalValueUptoTwoDigit = (number) => {
	// for two digit
	return Math.round((number + Number.EPSILON) * 100) / 100;
	// for one digit
	// return Math.round((number + Number.EPSILON) * 10) / 10;
};
export const convertValueInCr = (number, return_type = "number" || "string") => {
	// for two digit
	if (return_type === "number") return roundDecimalValueUptoTwoDigit(number / 10000000);
	else return `${roundDecimalValueUptoTwoDigit(number / 10000000)} (Cr)`;
	// for one digit
	// return Math.round((number + Number.EPSILON) * 10) / 10;
};
export const convertValueInL = (number, return_type = "number" || "string") => {
	// for two digit
	if (return_type === "number") return roundDecimalValueUptoTwo(number / 100000);
	else return `${roundDecimalValueUptoTwoDigit(number / 100000)}L`;
	// for one digit
	// return Math.round((number + Number.EPSILON) * 10) / 10;
};
export const convertValueInThousands = (number, return_type = "number" || "string") => {
	// for two digit
	if (return_type === "number") return roundDecimalValueUptoTwo(number / 1000);
	else return `${roundDecimalValueUptoTwoDigit(number / 1000)}K`;
	// for one digit
	// return Math.round((number + Number.EPSILON) * 10) / 10;
};
export const convertCrToNormalVaue = (number) => {
	// for two digit
	return roundDecimalValueUptoTwoDigit(number * 10000000);
	// for one digit
	// return Math.round((number + Number.EPSILON) * 10) / 10;
};
